module.exports = __webpack_public_path__ + "img/person-red.e9c1f075.svg";